import { createStyles, makeStyles } from '@material-ui/styles'

const styles = () => createStyles({
  orderDetailsWrapper: {
    padding: '0 23px 14px 25px',
  },
})

export default makeStyles(styles)
